import { pathJoin } from '../../../../routing/utils';

// Pure path map — no component imports. `saved` is the saved-reports + documents
// subroute (REQ-26); the section landing (`exact`) is the filter + table + export.
export const createRoutesMap = (prefix: string) => ({
  saved: pathJoin(prefix)('saved').chain,
});
